@if(modelArray?.length) {
@for(item of modelArray; track $index ){
@switch (model?.data && model?.type) {
@case ('page') {
<page-view [model]="model"></page-view>
}
@case ('category') {
<category-view [model]="model"></category-view>
}
@case ('product') {
@switch (productModel?.giftCard?.isGiftcard) {
@case (true) {
<giftcards-product-view cy-ppContainer
                        [modelId]="model.id"></giftcards-product-view>
}
@default {
<product-view cy-ppContainer
              [model]="model"></product-view>
}
}
}
@default {
<error-404></error-404>
}
}
}
} @else {
<error-404></error-404>
}